import React, { useState } from "react";
import { Helmet } from "react-helmet";
import HeaderThree from "../../../components/header/HeaderThree";
import CoreComponent31 from "../../../assets/Sub-component/CoreComponent31";
import CoreComponent32 from "../../../assets/Sub-component/CoreComponent32";
import "../../../assets/scss/_responsive.scss";
import "swiper/css";
import "swiper/css/navigation";
import CoreComponent35 from "../../../assets/Sub-component/CoreComponent35";
import OurLatestBlogs from "../../../assets/Sub-component/OurLatestBlogs";
import FooterTwo from "../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";

import ticks from "../../../assets/Services/tick-circle.png";
import CoreSlider from "../../../assets/Sub-component/CoreSlider";
import CoreSlider2 from "../../../assets/Sub-component/CoreSlider2";
import CoreComponent36 from "../../../assets/Sub-component/CoreComponent36";
import ClientExpCore from "../../../assets/Sub-component/ClientExpCore";
import CoreComponent37 from "../../../assets/Sub-component/CoreComponent37";
import { Link } from "react-router-dom";


import Maskgroup from '../../../assets/Services/VR_Game_Dev/Voice_of_Success/Maskgroup-1.png'
import Maskgroup2 from '../../../assets/Services/VR_Game_Dev/Voice_of_Success/Maskgroup-2.png'
import Maskgroup3 from '../../../assets/Services/VR_Game_Dev/Voice_of_Success/Maskgroup.png'

import AI_physical_integration from '../../../assets/Services/VR_Game_Dev/Our_VR_Game_Dev/AI_physical_integration.png'
import Full_VR_game_dev from '../../../assets/Services/VR_Game_Dev/Our_VR_Game_Dev/Full_VR_game_dev.png'
import Multi_ from '../../../assets/Services/VR_Game_Dev/Our_VR_Game_Dev/Multi_&_Social_VR.png'
import VR_Software_dev from '../../../assets/Services/VR_Game_Dev/Our_VR_Game_Dev/VR_Software_dev.png'
import VR_simulation from '../../../assets/Services/VR_Game_Dev/Our_VR_Game_Dev/VR_simulation&Training.png'

import D_Modeling from '../../../assets/Services/VR_Game_Dev/Key_Benefits_of_Raiden_Labs/3D_Modeling.svg'
import Gesture_Recognition from '../../../assets/Services/VR_Game_Dev/Key_Benefits_of_Raiden_Labs/Gesture_Recognition.svg'
import Image_Rec from '../../../assets/Services/VR_Game_Dev/Key_Benefits_of_Raiden_Labs/Image_Rec.svg'
import Motion_Tracking from '../../../assets/Services/VR_Game_Dev/Key_Benefits_of_Raiden_Labs/Motion_Tracking.svg'
import Physical_Simulation from '../../../assets/Services/VR_Game_Dev/Key_Benefits_of_Raiden_Labs/Physical_Simulation.svg'
import Spatial_Mapping from '../../../assets/Services/VR_Game_Dev/Key_Benefits_of_Raiden_Labs/Spatial_Mapping.svg'

import Concept_Validation from '../../../assets/Services/VR_Game_Dev/Experience_Raidens_VR/Concept_Validation.svg'
import Immersive_World from '../../../assets/Services/VR_Game_Dev/Experience_Raidens_VR/Immersive_World.svg'
import Market_Launch from '../../../assets/Services/VR_Game_Dev/Experience_Raidens_VR/Market_Launch.svg'
import Seamless_Performance from '../../../assets/Services/VR_Game_Dev/Experience_Raidens_VR/Seamless_Performance.svg'
import Vision_Blueprinting from '../../../assets/Services/VR_Game_Dev/Experience_Raidens_VR/Vision_Blueprinting.svg'


import Arcade_Game_Development from '../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Arcade_Game_Development.png'
import Bingo_Game_Development from '../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Bingo_Game_Development.png'
import Board_Game_Development from '../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Board_Game_Development.png'
import Ludo_Game_Development from '../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Ludo_Game_Development.png'
import Poker_Game_Development from '../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Poker_Game_Development.png'
import Rummy_Game_Development from '../../../assets/Services/Unreal_Engine_Game/Explore_our_other_games/Rummy_Game_Development.png'


import Deployment_ from '../../../assets/Services/Poker_Game_Dev/Experience_Raiden’s_Poker/Deployment_&_Maintenance.svg'
import Design_ from '../../../assets/Services/Poker_Game_Dev/Experience_Raiden’s_Poker/Design_&_Prototyping.svg'
import GameDevelopment from '../../../assets/Services/Poker_Game_Dev/Experience_Raiden’s_Poker/Game Development.svg'
import Requirement_Analysis from '../../../assets/Services/Poker_Game_Dev/Experience_Raiden’s_Poker/Requirement_Analysis.svg'
import Testing_ from '../../../assets/Services/Poker_Game_Dev/Experience_Raiden’s_Poker/Testing_&_Quality.svg'

import Creative from '../../../assets/Services/Unreal_Engine_Game/Un_real_exp/Creative-Tech_Synergy.svg'
import Enterprise from '../../../assets/Services/Unreal_Engine_Game/Un_real_exp/Enterprise-Grade_Security.svg'
import Full_cy from '../../../assets/Services/Unreal_Engine_Game/Un_real_exp/Full-Cycle_Development.svg'
import Platform_Expertise from '../../../assets/Services/Unreal_Engine_Game/Un_real_exp/Platform_Expertise.svg'
import Proven_Track_Record from '../../../assets/Services/Unreal_Engine_Game/Un_real_exp/Proven_Track_Record.svg'
import Reliable_Delivery from '../../../assets/Services/Unreal_Engine_Game/Un_real_exp/Reliable_Delivery.svg'

import icon from '../../../assets/Services/Game_page/Vr/icon.svg'
import icon2 from '../../../assets/Services/Game_page/Vr/icno2.png'
import icon3 from '../../../assets/Services/Game_page/Vr/icon3.png'
import FaqHome from "../../../components/faq/FaqHome";
import axios from "axios";
import Contact from "../features/miscellaneous/contact";


const VRGameDev = () => {
  const[form,setForm]=useState({name:'',email:'',mobile:'',message:''})
  const cards = [
    {
      title: "Full VR Game Development ",
      desc: "We oversee every aspect of creating VR games, from conception to release and beyond. Our comprehensive experience guarantees a seamless, high-performing product designed for the utmost player satisfaction.",
      img:  Full_VR_game_dev   ,
    },
    
    {
      title: "VR Simulation and Training",
      desc: "We create strong VR simulations for efficient training in a variety of industries, in addition to providing entertainment. These offer professionals safe, experiential learning settings that improve retention and practical performance.",
      img:  VR_simulation,
    },
    {
      title: "Multiplayer and Social VR ",
      desc: "Our strong multiplayer frameworks facilitate smooth social interaction and cooperative virtual environments. By extending game longevity through shared adventures, our solutions create lively communities.",
      img: Multi_ ,
    },
    
    {
      title: "VR Software Development",
      desc: "Leveraging cutting-edge tools like Unity and Unreal Engine, our developers build robust, scalable VR applications. We focus on optimized code and innovative solutions for fluid, high-fidelity virtual experiences.",
      img: VR_Software_dev ,
    },
    
    {
      title: " AI & Physics Integration  ",
      desc: " We infuse intelligence into your VR worlds with advanced AI for dynamic NPCs and adaptive gameplay, alongside realistic physics engines that enhance interactivity and immersion, making virtual environments feel truly alive.  ",
      img:  AI_physical_integration,
    },
  
  ];
 

  const gamedevservices = [
    {
      title: "Arcade Game Development",
      icon:Arcade_Game_Development,
      desc: " Design adrenaline-charged arcade experiences with fast-paced gameplay, eye-catching visuals, and high replayability—optimized for both mobile and web platforms.",
      link: "/arcade-game-development",
    },
    {
      title: "Poker  Game Development  ",
      icon:Poker_Game_Development,
      desc: " Our poker platforms feature secure, scalable game logic, support for multiple variants, and tournament systems. We implement advanced encryption for transactions and provide intuitive user interfaces for optimal player experience.",
      link: "/poker-game-development",
    },
    {
      title: "Bingo Game Development",
      icon:Bingo_Game_Development,
      desc: " Reimagine bingo digitally with dynamic formats like 75-ball, 90-ball, and speed bingo. Enrich the experience with real-time chat, leaderboards, social features, and scalable server infrastructure.",
      link: "/bingo-game-development",
    },
    {
      title: " Board Game Development",
      icon:Board_Game_Development,
      desc: " Bring timeless board games like Ludo, Chess, and Monopoly to digital life with intuitive interfaces, real-time multiplayer capabilities, and socially engaging mechanics.",
      link: "/board-game-development",
    },
    {
      title: "Ludo Game Development",
      icon:Ludo_Game_Development,
      desc: "We build modern Ludo games with real-time multiplayer, secure matchmaking, and responsive UI. Our implementations support cross-platform play and robust backend integration for analytics and user management.",
      link: "/ludo-game-development",
    },
    {
      title: " Rummy Game Development",
      icon:Rummy_Game_Development,
      desc: " Develop scalable and secure Rummy solutions that offer smooth gameplay and high-performance backend support.",
      link: "/rummy-game-development",
    },
  ];

  const custom = [
    {
      icon: Motion_Tracking,
      title: "Motion Tracking",
      desc: "This gives players a strong sense of presence and natural control, lessens motion sickness, and makes interactions responsive by synchronizing real and virtual movement.",
    },
    {
      icon: D_Modeling,
      title: "3D Modeling and Rendering  ",
      desc: "Our team places a high value on accurate rendering and painstaking detail to immerse users in realistic, rich virtual worlds that enhance their enjoyment and immersion.",
    },
    {
      icon: Gesture_Recognition,
      title: "Gesture Recognition",
      desc: "We implement an intuitive and immersive control scheme, deepening player connection as they use natural gestures to manipulate objects or cast spells.",
    },
    {
      icon: Spatial_Mapping,
      title: " Spatial Mapping  ",
      desc: "  Our expertise creates dynamic, interactive environments where virtual elements intelligently interact with the real world, enhancing safety and immersion in room-scale VR for expansive gameplay.  ",
    },
    {
      icon: Image_Rec,
      title: " Image Recognition ",
      desc: "  We integrate innovative gameplay possibilities, allowing players to use real-world items as virtual tools or create unique interaction layers.  ",
    },
    {
      icon: Physical_Simulation,
      title: " Physical Simulation ",
      desc: "  Our development adds realism and interactivity, which gives objects a tangible feel and actions plausible outcomes, leading to deeper engagement and replayability.  ",
    },
  ];

  const technologies = [
    {
      icon: '',
      title: "  Frontend",
      desc: "Swift",
      desc2: " Flutter",
      desc3: " React Native",
    },

    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/05/14043800/refferal-bonus-system.webp",
      title: " Backend ",
      desc: " Node.js",
      desc2: " Python",
      desc3: " .NET Core",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/05/14043800/refferal-bonus-system.webp",
      title: "Databases  ",
      desc: "PostgreSQL ",
      desc2: " MongoDB",
      desc3: " Firebase",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/05/14043800/refferal-bonus-system.webp",
      title: "Cloud & Hosting  ",
      desc: " AWS",
      desc2: " Google Cloud",
      desc3: " Azure",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/05/14043800/refferal-bonus-system.webp",
      title: "  APIs & Integrations",
      desc: " GraphQL",
      desc2: " SOAP",
      desc3: "Twilio ",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/05/14043800/refferal-bonus-system.webp",
      title: " Testing Tools ",
      desc: " Appium",
      desc2: " Selenium",
      desc3: " Anti-Fraud System",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/05/14043800/refferal-bonus-system.webp",
      title: "DevOps & CI/CD  ",
      desc: " GitLab CI/CD",
      desc2: " Jenkins",
      desc3: " Docker",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/05/14043800/refferal-bonus-system.webp",
      title: "  Analytics & Monitoring",
      desc: " Google Analytics",
      desc2: " Firebase Analytics",
      desc3: " Sentry",
    },
  ];

  const card = [
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/01/03174014/Group-105742.webp",
      title: "mobile",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/01/03174014/Group-105742.webp",
      title: "PC ",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/01/03174014/Group-105742.webp",
      title: "TABLET ",
    },
    {
      icon: "https://sdlccorp-web-prod.blr1.digitaloceanspaces.com/wp-content/uploads/2025/01/03174014/Group-105742.webp",
      title: "CONSOLE",
    },
  ];
const pokerdevcompany2 = [
  {
      title: " Full-Cycle Development ",
      icon: Full_cy,
      desc: "We manage your VR game from concept to launch and beyond, ensuring a cohesive vision and high-quality product without multi-vendor complexity.   ",
    },
    {
      title: "Proven Track Record  ",
      icon: Proven_Track_Record,
      desc: "With over a decade of successful game launches, our expertise guarantees reliable project management and games that deeply resonate with players.   ",
    },
    {
      title: "Platform Expertise  ",
      icon: Platform_Expertise,
      desc: "Our deep knowledge across all major platforms ensures your game is optimized for maximum performance and broad reach on any chosen device.  ",
    },
    {
      title: " Enterprise-Grade Security ",
      icon: Enterprise,
      desc: "  We prioritize robust data integrity and intellectual property protection, offering advanced security protocols and transparent oversight throughout development. ",
    },
    {
      title: "Creative-Tech Synergy  ",
      icon: Creative,
      desc: "Our flawless combination of artistic vision and technical innovation pushes the boundaries, offering cutting-edge experiences without compromising player comfort.   ",
    },
    {
      title: " Reliable Delivery ",
      icon: Reliable_Delivery,
      desc: "We commit to predictable timelines and consistent communication, ensuring on-schedule, on-budget project delivery with full transparency.   ",
    },
    
  ];


  const pokerdevcompany = [
    {
      title: "Vision Blueprinting ",
      icon: Vision_Blueprinting  ,
      desc: "We work closely together to establish the main goals of your VR game, making sure that they are completely in line with both user expectations and your strategic goals. ",
    },
    {
      title: "Concept Validation ",
      icon: Concept_Validation  ,
      desc: "We rapidly develop interactive VR prototypes in order to test and refine the core mechanics and user experience prior to fully developing the project. ",
    },
    {
      title: "Immersive World Building ",
      icon: Immersive_World  ,
      desc: "Our experts build immersive virtual reality environments with realistic graphics, engaging gameplay, and intuitive user interfaces. ",
    },
    {
      title: " Seamless Performance Assurance",
      icon: Seamless_Performance  ,
      desc: "We meticulously assemble each component and extensively test it across multiple VR platforms to guarantee faultless, error-free operation. ",
    },
    {
      title: "Market Launch & Evolution ",
      icon: Market_Launch  ,
      desc: "After a successful market launch, we provide continuing maintenance and support to guarantee continued engagement. ",
    },
   
    
  ];

  const clientexp = [
    {
      icon: Maskgroup,
      name: "Isabella Rossi",

      desc: "Their developers made sure that everything ran smoothly, and their creative team made our vision a reality with their inventive gameplay and breathtaking graphics. A fantastic collaboration!",
    },
    {
      icon:Maskgroup2 ,
      name: "Anya Petrova ",
      undername: " ",
      desc: "Raiden Labs provided exceptional technical expertise for our intricate VR project. They navigated challenging physics and multiplayer integration with ease, delivering a high-performance title that exceeded our expectations on every platform",
    },
    {
      icon: Maskgroup3,
      name: "Kenji Tanaka",
      undername: "  ",
      desc: "Security and reliability were paramount for our social VR application. Raiden Labs provided enterprise-grade solutions and unwavering support, giving us complete confidence in our product's integrity and long-term success",
    },
  ];
  const handleClick=(e)=>{
    e.preventDefault()
   axios.post('http://localhost:5000/contact',form) 
   .then((response)=>{setForm(response.data)
    console.log("data subitted successfully")
    setForm({ name: '', email: '', mobile: '', message: '' }); 
   })
   .catch((error)=>console.log("error in the api",error))
  
  }

  return (
    <div className="main-page-wrapper overflow-x-hidden">
      <Helmet>
        <title>Customer Support || Deski-Saas & Software React Template</title>
      </Helmet>
      <HeaderThree />
      <div className="container  marb " style={{ minHeight: "100vh" }}>
        <div className="  row  text-center d-flex justify-content-center align-items-center  text-lg-start  topheader-margin"      style={{ minHeight: "100vh"}}  >
          <div className="col-lg-6">
            <h1 className="lh-1 h1-heading fs-lg-2 ">
              Virtual Reality Game Development
            </h1>
            <p className=" mt-3 mb-2 text-center text-lg-start px-3 px-lg-0  h1-para">
              Raiden Labs has been at the forefront of the gaming industry for
              more than ten years, regularly producing aesthetically stunning
              and incredibly captivating game worlds. We constantly push the
              boundaries of technology with the goal of creating entertaining and memorable VR gaming experiences..
            </p>

            <Link to="/request-quote">
              <button className="py-2 mb-4 h1-para mx-auto px-4 btn-gradient rounded-2 text-white mt-3">
                Get a Quote
              </button>
            </Link>
          </div>
         <Contact/>
        </div>
      </div>

      <div className="container  ">
        <div className=" row">
          <div className=" col-lg-6 text-center mb-4">
            <img src={icon} style={{ width: "100%" }} alt="" />
          </div>
          <div className="col-lg-6">
            <h2 className="h2-heading lh-base">
              Crafting Immersive Worlds: Our Expertise
            </h2>
            <p className="mt-4  h1-para" >
              Raiden Labs has been developing software for more than a decade,
              and they are expert at turning innovative VR game ideas into
              finished, immersive products. Our top priorities are developing
              user-friendly player environments, incorporating state-of-the-art
              VR technologies, and designing comfort-focused mechanics to avoid
              motion sickness. Raiden Labs additionally ensures open development
              monitoring and complete intellectual property rights for its
              clients. We also use cutting-edge technologies like blockchain and
              NFTs to improve your virtual reality game, solidifying its high
              standing in the digital market and creating new opportunities for
              player ownership and engagement.
            </p>
            <ul className="mt-3 h1-para">
              <li className="d-flex align-items-center mt-1">
                <img
                  src={ticks}
                  alt=""
                  className="m-0 me-2"
                  style={{ width: 20, height: 20 }}
                />{" "}
                Multi-currency support for international markets
              </li>
              <li className="d-flex align-items-center mt-1">
                <img
                  src={ticks}
                  alt=""
                  className="m-0 me-2"
                  style={{ width: 20, height: 20 }}
                />{" "}
                Provably fair gaming with blockchain confirmation
              </li>
              <li className="d-flex align-items-center mt-1">
                <img
                  src={ticks}
                  alt=""
                  className="m-0 me-2"
                  style={{ width: 20, height: 20 }}
                />{" "}
                Responsible gambling tools and features
              </li>
            </ul>
            <Link to="/request-quote">
              <button className="py-2 h1-para mx-auto px-4 btn-gradient rounded-2 text-white mt-3">
                Get a custom demo
              </button>
            </Link>
          </div>
        </div>
      </div>

      <div className="container mt-80 text-center">
        <h2 className="h2-heading lh-base ">
          Our VR Game Development Services
        </h2>
        <p className="mt-2 h1-para ">
          {" "}
          We at Raiden Labs turn innovative ideas into ground-breaking virtual
          reality experiences. Our extensive services guarantee that your
          project not only satisfies but surpasses industry standards, providing
          your audience with unmatched immersion and engagement.
        </p>
        <CoreSlider cards={cards} />
      </div>

      <div className="mt-80  text-center bg-light pt-50 pb-50 mart">
        <div className="container">
          <h2 className="text-center lh-base  mb-3 h2-heading ">
            Key Benefits of Raiden Labs' VR Game Development
          </h2>
          <p className="mb-4 pb-2 text-center mx-lg-4">
            At Raiden Labs, we incorporate state-of-the-art features to create
            VR games that are genuinely next-generation. These core technologies
            are the bedrock of unparalleled immersion, intuitive interaction,
            and believable virtual worlds, ensuring a superior experience for
            our clients' audiences.
          </p>
          <CoreComponent31 custom={custom} />
          <Link to="/request-quote">
            <button className="py-2 px-4 mx-auto h1-para btn-gradient rounded-3 text-white mt-3">
              Buy online poker software
            </button>
          </Link>
        </div>
      </div>

      <div className="bg-black text-white mt-80 mart mart">
        <div className="container p-4">
          <div className="row">
            <div className="col-lg-6">
              <h2 className="lh-base mb-3   h2-heading text-white text-start">
                Integrate VR to sense and engage with your vision game.
              </h2>
              <p
                className="h3-para lh-base  text-lg-start"
                style={{ opacity: 0.6 }}
              >
                Raiden Labs' cutting-edge, high-performance virtual reality game
                development produces an engaging gaming experience that embraces
                not just your devices but also your reality.{" "}
              </p>
              <Link to="/request-quote">
              <button className="py-2 mt-4 px-4 h1-para mx-auto mx-lg-0 btn-gradient rounded-3 text-white ">
                TALK WITH OUR EXPERTS NOW!
              </button>
              </Link>
            </div>
            <div className="col-lg-6">
              <img src={icon2} alt=""  className="img-big-game"/>
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-80 mart ">
        <div className="">
          <h2 className="text-center h2-heading lh-sm">
            Raiden’s Advanced Tech and Flawless VR.
          </h2>
          <p className="h1-para mb-4  text-center mt-3 mx-lg-4 pb-2">
            Raiden Labs integrates a skilled tech stack that supports compliance
            to create a distinctive and cutting-edge VR gameplay  experience.
          </p>
          <CoreComponent32  />
          <Link to="/request-quote">
            <button className="py-2 mt-4 px-4 mx-auto btn-gradient rounded-3 text-white ">
              Schedule a demo
            </button>
          </Link>
        </div>
      </div>

      <div className="container mt-80 mart">
        <div className="row">
          <div className="col-md-6">
            <h2 className="h2-heading mb-2 lh-base">
              Raiden's Universal VR: Seamless Across Devices{" "}
            </h2>
          </div>
          <div className="col-md-6">
            <p className="h1-para  mb-3  ">
             Raiden Labs’ platform’s real-time synchronization and flawless
              performance guarantees enable players to switch between screens
              without losing progress. Just a lag-free, compatible experience
              that is consistent and optimized everywhere. Essentially, we
              ensure that your VR app stays stable and usable, boosting user
              engagement on all platforms
            </p>

            <CoreComponent37  />
          </div>
        </div>
      </div>

      <div className="bg-black text-white mt-80 mart mart">
        <div className="container p-4">
          <div className="row">
            <div className="col-lg-6">
              <h2 className="h2-heading lh-base mb-2 fs-3 text-white mb-lg-3">
                Looking for VR Game Developers?
              </h2>
             <p className="h1-para text-white  lh-base" style={{ opacity: 0.6 }}>
                We build market-leading VR games with Unity, Unreal Engine,
                Node.js, blockchain technology, and enterprise cloud
                infrastructure. With photorealistic graphics, certified RNG
                systems, and full regulatory compliance, we ensure top-notch
                gaming experiences and effective security measures.
              </p>
              <Link to="/request-quote">
                <button className="h1-para mx-auto mx-lg-0 py-2 mt-4 px-4  btn-gradient rounded-3 text-white ">
                  Let’s connect
                </button>
              </Link>
            </div>
            <div className="col-lg-6 d-none d-lg-block">
              <img src={icon3} alt="" className="img-big-game" />
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-80 text-center">
        <h2 className="h2-heading lh-base mb-3">
          Experience Raiden's VR Game Development
        </h2>
        <p className="lh-base mb-3 pb-2 h1-para">
          Choosing Raiden Labs for your VR game will benefit your project from a
          seamless process, cutting-edge technology, and a proven track record
          of success. Raiden Labs is a leader in producing exceptional virtual
          experiences.
        </p>
        <div>
          <CoreComponent36 pokerdevcompany={pokerdevcompany2} />

          <Link to="/request-quote">
            <button className="py-2 mt-4 px-4 mx-auto btn-gradient rounded-3 text-white ">
              Schedule a demo
            </button>
          </Link>
        </div>
      </div>

      <div className="container mt-80 text-center ">
        <h2 className="h2-heading lh-base ">Explore our other games</h2>
        <p className="my-3 pb-2 mx-3 h1-para">
          We specialize in developing immersive and feature-rich games tailored
          for both casual and competitive players. Our expertise ensures secure,
          fair, and scalable platforms with real-time multiplayer functionality.
          With stunning visuals and intuitive gameplay, our games keep users
          engaged and coming back for more.
        </p>

        <CoreSlider2 gamedevservices={gamedevservices} />
      </div>

      <div className="container mt-80 mart ">
        <h2 className="text-center lh-base h2-heading ">Our VR Game Development Process</h2>
        <p className="h1-para my-3 fs-6 mx-lg-4  text-center">
          At Raiden Labs, we transform your VR vision into a compelling reality
          through a meticulously structured process, ensuring efficiency,
          quality, and exceptional player experiences.
        </p>

        <CoreComponent35 pokerdevcompany={pokerdevcompany} />
      </div>

      <div className="container mt-80 mart">
        <h2 className="h2-heading lh-base mb-2 text-center">
          {" "}
          Voice of Success from our clients
        </h2>
        <p className="lh-base text-center mb-4 pb-2 h1-para">
          Listen to people who have partnered with us directly. These
          endorsements demonstrate Raiden Labs' dedication to quality,
          creativity, and customer satisfaction in the production of VR games.
        </p>
        <ClientExpCore clientexp={clientexp} />
      </div>

      <div className="">
        <OurLatestBlogs />
      </div>
      {/* <FaqHome/> */}

      <footer className="theme-footer-two pt-80 padt">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default VRGameDev;
